import EventListener from 'wolfy87-eventemitter';

import { SESSION_FORM_DATA_KEY, encodeDecodeTypes } from '../constants';
import JraAddComponent from '../JraAddComponent';
import { isCustomValidInput } from '../helpers';

export default class JraEncodeDecodeModule extends EventListener {
  constructor(key) {
    super();
    this.key = key;
  }

  static generatePropertyName(element, stub, index) {
    return `${stub}|${element.nodeName.toLowerCase()}|${element.type}|${element.id}|${element.name}|${index}`;
  }

  getEncodedSessionData() {
    const data = window.sessionStorage.getItem(SESSION_FORM_DATA_KEY);

    if (data) {
      const parsedData = JSON.parse(data);
      if (!parsedData.modules || !parsedData.modules[this.key]) return undefined;

      const moduleData = parsedData.modules[this.key];

      return moduleData;
    }

    return undefined;
  }


  encode(data) {
    const module = {};

    // inputs
    const formInputs = [...this.element.querySelectorAll('[data-form="input"]')];
    formInputs.forEach((input, index) => {
      let value;
      switch (input.type) {
        case 'radio':
          value = input.checked;
          break;
        case 'checkbox':
          value = input.checked;
          break;
        default:
          value = input.value;
      }

      const propertyName = JraEncodeDecodeModule.generatePropertyName(
        input, encodeDecodeTypes.FORM_INPUT, index,
      );
      module[propertyName] = value;
    });

    // expandable sections
    const expandableSections = [...this.element.querySelectorAll('[data-jra-form-expandable-section]')];
    expandableSections.forEach((section, index) => {
      const propertyName = JraEncodeDecodeModule.generatePropertyName(
        section, encodeDecodeTypes.EXPANDABLE, index,
      );
      module[propertyName] = section.classList.contains('expanded');
    });

    data[this.key] = module;
  }

  decode() {
    const module = this.getEncodedSessionData();
    if (!module) return;

    Object.keys(module).forEach((propertyName) => {
      const args = propertyName.split('|');
      args.push(module[propertyName]);
      const stub = args[0];

      this.decodeItem(stub, args);
    });
  }

  decodeItem = (stub, args) => {
    switch (stub) {
      case encodeDecodeTypes.FORM_INPUT:
        JraEncodeDecodeModule.decodeInput(...args);
        break;
      case encodeDecodeTypes.EXPANDABLE:
        this.decodeExpandable(...args);
        break;
      default:
        break;
    }
  }

  static decodeInput(_stub, _nodeName, type, id, _name, _index, value) {
    let selector = '';

    if (id) {
      selector += `${id}`;
    }

    if (selector) {
      const input = document.getElementById(selector);
      if (input) {
        if (type !== 'checkbox' && type !== 'radio') {
          input.value = value;
        } else {
          input.checked = value;
        }
        isCustomValidInput(input);
      } else {
        console.log(`can't find input ${selector}`);
      }
    }
  }

  decodeExpandable(_stub, _nodeName, _type, _id, _name, index, isExpanded) {
    const expandableSections = [...this.element.querySelectorAll('[data-jra-form-expandable-section]')];
    const expandableSection = expandableSections[index];
    if (expandableSection && isExpanded) {
      expandableSection.classList.add('expanded');
      expandableSection.style.height = 'auto';
      JraAddComponent.enableFormInputs(expandableSection);
    } else if (expandableSection && !isExpanded) {
      expandableSection.classList.remove('expanded');
      JraAddComponent.disableFormInputs(expandableSection);
    } else {
      console.log(`can't find expanded ${index}`);
    }
  }
}
